export type CountryOption = {
  /** Demonym shown to the user, e.g. "Indian". */
  label: string;  /** ISO 3166-1 alpha-2 country code persisted on the staff record, e.g. "IN". */
  value: string;
  pattern: RegExp;
};

/** Demonyms keyed by ISO 3166-1 alpha-2 code, sorted by label. */
export const COUNTRY_CODES: CountryOption[] = [
  { label: "AF (+93)", value: "+93", pattern: /^\d{9}$/ },
  { label: "AL (+355)", value: "+355", pattern: /^\d{8,9}$/ },
  { label: "DZ (+213)", value: "+213", pattern: /^\d{9}$/ },
  { label: "US (+1)", value: "+1", pattern: /^\d{10}$/ },
  { label: "AD (+376)", value: "+376", pattern: /^\d{6}$/ },
  { label: "AO (+244)", value: "+244", pattern: /^\d{9}$/ },
  { label: "AG (+1)", value: "+1", pattern: /^\d{10}$/ },
  { label: "AR (+54)", value: "+54", pattern: /^\d{10}$/ },
  { label: "AM (+374)", value: "+374", pattern: /^\d{8}$/ },
  { label: "AU (+61)", value: "+61", pattern: /^\d{9}$/ },
  { label: "AT (+43)", value: "+43", pattern: /^\d{10,13}$/ },
  { label: "AZ (+994)", value: "+994", pattern: /^\d{9}$/ },
  { label: "BS (+1)", value: "+1", pattern: /^\d{10}$/ },
  { label: "BH (+973)", value: "+973", pattern: /^\d{8}$/ },
  { label: "BD (+880)", value: "+880", pattern: /^\d{10}$/ },
  { label: "BB (+1)", value: "+1", pattern: /^\d{10}$/ },
  { label: "LS (+266)", value: "+266", pattern: /^\d{8}$/ },
  { label: "BY (+375)", value: "+375", pattern: /^\d{9}$/ },
  { label: "BE (+32)", value: "+32", pattern: /^\d{9}$/ },
  { label: "BZ (+501)", value: "+501", pattern: /^\d{7}$/ },
  { label: "BJ (+229)", value: "+229", pattern: /^\d{8}$/ },
  { label: "BT (+975)", value: "+975", pattern: /^\d{8}$/ },
  { label: "BO (+591)", value: "+591", pattern: /^\d{8}$/ },
  { label: "BA (+387)", value: "+387", pattern: /^\d{8}$/ },
  { label: "BW (+267)", value: "+267", pattern: /^\d{8}$/ },
  { label: "BR (+55)", value: "+55", pattern: /^\d{10,11}$/ },
  { label: "BN (+673)", value: "+673", pattern: /^\d{7}$/ },
  { label: "BG (+359)", value: "+359", pattern: /^\d{8,9}$/ },
  { label: "BF (+226)", value: "+226", pattern: /^\d{8}$/ },
  { label: "MM (+95)", value: "+95", pattern: /^\d{8,10}$/ },
  { label: "BI (+257)", value: "+257", pattern: /^\d{8}$/ },
  { label: "CV (+238)", value: "+238", pattern: /^\d{7}$/ },
  { label: "KH (+855)", value: "+855", pattern: /^\d{8,9}$/ },
  { label: "CM (+237)", value: "+237", pattern: /^\d{9}$/ },
  { label: "CA (+1)", value: "+1", pattern: /^\d{10}$/ },
  { label: "CF (+236)", value: "+236", pattern: /^\d{8}$/ },
  { label: "TD (+235)", value: "+235", pattern: /^\d{8}$/ },
  { label: "CL (+56)", value: "+56", pattern: /^\d{9}$/ },
  { label: "CN (+86)", value: "+86", pattern: /^\d{11}$/ },
  { label: "CO (+57)", value: "+57", pattern: /^\d{10}$/ },
  { label: "KM (+269)", value: "+269", pattern: /^\d{7}$/ },
  { label: "CD (+243)", value: "+243", pattern: /^\d{9}$/ },
  { label: "CG (+242)", value: "+242", pattern: /^\d{9}$/ },
  { label: "CR (+506)", value: "+506", pattern: /^\d{8}$/ },
  { label: "HR (+385)", value: "+385", pattern: /^\d{8,9}$/ },
  { label: "CU (+53)", value: "+53", pattern: /^\d{8}$/ },
  { label: "CY (+357)", value: "+357", pattern: /^\d{8}$/ },
  { label: "CZ (+420)", value: "+420", pattern: /^\d{9}$/ },
  { label: "DK (+45)", value: "+45", pattern: /^\d{8}$/ },
  { label: "DJ (+253)", value: "+253", pattern: /^\d{8}$/ },
  { label: "DM (+1)", value: "+1", pattern: /^\d{10}$/ },
  { label: "DO (+1)", value: "+1", pattern: /^\d{10}$/ },
  { label: "NL (+31)", value: "+31", pattern: /^\d{9}$/ },
  { label: "TL (+670)", value: "+670", pattern: /^\d{8}$/ },
  { label: "EC (+593)", value: "+593", pattern: /^\d{9}$/ },
  { label: "EG (+20)", value: "+20", pattern: /^\d{10}$/ },
  { label: "AE (+971)", value: "+971", pattern: /^\d{9}$/ },
  { label: "GQ (+240)", value: "+240", pattern: /^\d{9}$/ },
  { label: "ER (+291)", value: "+291", pattern: /^\d{7}$/ },
  { label: "EE (+372)", value: "+372", pattern: /^\d{7,8}$/ },
  { label: "SZ (+268)", value: "+268", pattern: /^\d{8}$/ },
  { label: "ET (+251)", value: "+251", pattern: /^\d{9}$/ },
  { label: "FJ (+679)", value: "+679", pattern: /^\d{7}$/ },
  { label: "PH (+63)", value: "+63", pattern: /^\d{10}$/ },
  { label: "FI (+358)", value: "+358", pattern: /^\d{9,10}$/ },
  { label: "FR (+33)", value: "+33", pattern: /^\d{9}$/ },
  { label: "GA (+241)", value: "+241", pattern: /^\d{8}$/ },
  { label: "GM (+220)", value: "+220", pattern: /^\d{7}$/ },
  { label: "GE (+995)", value: "+995", pattern: /^\d{9}$/ },
  { label: "DE (+49)", value: "+49", pattern: /^\d{10,11}$/ },
  { label: "GH (+233)", value: "+233", pattern: /^\d{9}$/ },
  { label: "GR (+30)", value: "+30", pattern: /^\d{10}$/ },
  { label: "GD (+1)", value: "+1", pattern: /^\d{10}$/ },
  { label: "GT (+502)", value: "+502", pattern: /^\d{8}$/ },
  { label: "GW (+245)", value: "+245", pattern: /^\d{7}$/ },
  { label: "GN (+224)", value: "+224", pattern: /^\d{9}$/ },
  { label: "GY (+592)", value: "+592", pattern: /^\d{7}$/ },
  { label: "HT (+509)", value: "+509", pattern: /^\d{8}$/ },
  { label: "HN (+504)", value: "+504", pattern: /^\d{8}$/ },
  { label: "HK (+852)", value: "+852", pattern: /^\d{8}$/ },
  { label: "HU (+36)", value: "+36", pattern: /^\d{8,9}$/ },
  { label: "IS (+354)", value: "+354", pattern: /^\d{7}$/ },
  { label: "IN (+91)", value: "+91", pattern: /^\d{10}$/ },
  { label: "ID (+62)", value: "+62", pattern: /^\d{9,12}$/ },
  { label: "IR (+98)", value: "+98", pattern: /^\d{10}$/ },
  { label: "IQ (+964)", value: "+964", pattern: /^\d{10}$/ },
  { label: "IE (+353)", value: "+353", pattern: /^\d{9}$/ },
  { label: "IL (+972)", value: "+972", pattern: /^\d{9}$/ },
  { label: "IT (+39)", value: "+39", pattern: /^\d{9,10}$/ },
  { label: "CI (+225)", value: "+225", pattern: /^\d{10}$/ },
  { label: "JM (+1)", value: "+1", pattern: /^\d{10}$/ },
  { label: "JP (+81)", value: "+81", pattern: /^\d{10}$/ },
  { label: "JO (+962)", value: "+962", pattern: /^\d{9}$/ },
  { label: "KZ (+7)", value: "+7", pattern: /^\d{10}$/ },
  { label: "KE (+254)", value: "+254", pattern: /^\d{9}$/ },
  { label: "KI (+686)", value: "+686", pattern: /^\d{5}$/ },
  { label: "XK (+383)", value: "+383", pattern: /^\d{8}$/ },
  { label: "KW (+965)", value: "+965", pattern: /^\d{8}$/ },
  { label: "KG (+996)", value: "+996", pattern: /^\d{9}$/ },
  { label: "LA (+856)", value: "+856", pattern: /^\d{8,10}$/ },
  { label: "LV (+371)", value: "+371", pattern: /^\d{8}$/ },
  { label: "LB (+961)", value: "+961", pattern: /^\d{7,8}$/ },
  { label: "LR (+231)", value: "+231", pattern: /^\d{7,8}$/ },
  { label: "LY (+218)", value: "+218", pattern: /^\d{9}$/ },
  { label: "LI (+423)", value: "+423", pattern: /^\d{7}$/ },
  { label: "LT (+370)", value: "+370", pattern: /^\d{8}$/ },
  { label: "LU (+352)", value: "+352", pattern: /^\d{9}$/ },
  { label: "MO (+853)", value: "+853", pattern: /^\d{8}$/ },
  { label: "MG (+261)", value: "+261", pattern: /^\d{9}$/ },
  { label: "MW (+265)", value: "+265", pattern: /^\d{9}$/ },
  { label: "MY (+60)", value: "+60", pattern: /^\d{9,10}$/ },
  { label: "MV (+960)", value: "+960", pattern: /^\d{7}$/ },
  { label: "ML (+223)", value: "+223", pattern: /^\d{8}$/ },
  { label: "MT (+356)", value: "+356", pattern: /^\d{8}$/ },
  { label: "MH (+692)", value: "+692", pattern: /^\d{7}$/ },
  { label: "MR (+222)", value: "+222", pattern: /^\d{8}$/ },
  { label: "MU (+230)", value: "+230", pattern: /^\d{8}$/ },
  { label: "MX (+52)", value: "+52", pattern: /^\d{10}$/ },
  { label: "FM (+691)", value: "+691", pattern: /^\d{7}$/ },
  { label: "MD (+373)", value: "+373", pattern: /^\d{8}$/ },
  { label: "MC (+377)", value: "+377", pattern: /^\d{8,9}$/ },
  { label: "MN (+976)", value: "+976", pattern: /^\d{8}$/ },
  { label: "ME (+382)", value: "+382", pattern: /^\d{8}$/ },
  { label: "MA (+212)", value: "+212", pattern: /^\d{9}$/ },
  { label: "MZ (+258)", value: "+258", pattern: /^\d{9}$/ },
  { label: "NA (+264)", value: "+264", pattern: /^\d{9}$/ },
  { label: "NR (+674)", value: "+674", pattern: /^\d{7}$/ },
  { label: "NP (+977)", value: "+977", pattern: /^\d{10}$/ },
  { label: "NZ (+64)", value: "+64", pattern: /^\d{8,10}$/ },
  { label: "NI (+505)", value: "+505", pattern: /^\d{8}$/ },
  { label: "NG (+234)", value: "+234", pattern: /^\d{10}$/ },
  { label: "NE (+227)", value: "+227", pattern: /^\d{8}$/ },
  { label: "KP (+850)", value: "+850", pattern: /^\d{8,10}$/ },
  { label: "MK (+389)", value: "+389", pattern: /^\d{8}$/ },
  { label: "NO (+47)", value: "+47", pattern: /^\d{8}$/ },
  { label: "OM (+968)", value: "+968", pattern: /^\d{8}$/ },
  { label: "PK (+92)", value: "+92", pattern: /^\d{10}$/ },
  { label: "PW (+680)", value: "+680", pattern: /^\d{7}$/ },
  { label: "PS (+970)", value: "+970", pattern: /^\d{9}$/ },
  { label: "PA (+507)", value: "+507", pattern: /^\d{8}$/ },
  { label: "PG (+675)", value: "+675", pattern: /^\d{8}$/ },
  { label: "PY (+595)", value: "+595", pattern: /^\d{9}$/ },
  { label: "PE (+51)", value: "+51", pattern: /^\d{9}$/ },
  { label: "PL (+48)", value: "+48", pattern: /^\d{9}$/ },
  { label: "PT (+351)", value: "+351", pattern: /^\d{9}$/ },
  { label: "PR (+1)", value: "+1", pattern: /^\d{10}$/ },
  { label: "QA (+974)", value: "+974", pattern: /^\d{8}$/ },
  { label: "RO (+40)", value: "+40", pattern: /^\d{9}$/ },
  { label: "RU (+7)", value: "+7", pattern: /^\d{10}$/ },
  { label: "RW (+250)", value: "+250", pattern: /^\d{9}$/ },
  { label: "KN (+1)", value: "+1", pattern: /^\d{10}$/ },
  { label: "LC (+1)", value: "+1", pattern: /^\d{10}$/ },
  { label: "VC (+1)", value: "+1", pattern: /^\d{10}$/ },
  { label: "SV (+503)", value: "+503", pattern: /^\d{8}$/ },
  { label: "WS (+685)", value: "+685", pattern: /^\d{7}$/ },
  { label: "SM (+378)", value: "+378", pattern: /^\d{10}$/ },
  { label: "ST (+239)", value: "+239", pattern: /^\d{7}$/ },
  { label: "SA (+966)", value: "+966", pattern: /^\d{9}$/ },
  { label: "SN (+221)", value: "+221", pattern: /^\d{9}$/ },
  { label: "RS (+381)", value: "+381", pattern: /^\d{8,9}$/ },
  { label: "SC (+248)", value: "+248", pattern: /^\d{7}$/ },
  { label: "SL (+232)", value: "+232", pattern: /^\d{8}$/ },
  { label: "SG (+65)", value: "+65", pattern: /^\d{8}$/ },
  { label: "SK (+421)", value: "+421", pattern: /^\d{9}$/ },
  { label: "SI (+386)", value: "+386", pattern: /^\d{8}$/ },
  { label: "SB (+677)", value: "+677", pattern: /^\d{7}$/ },
  { label: "SO (+252)", value: "+252", pattern: /^\d{8}$/ },
  { label: "ZA (+27)", value: "+27", pattern: /^\d{9}$/ },
  { label: "KR (+82)", value: "+82", pattern: /^\d{9,10}$/ },
  { label: "SS (+211)", value: "+211", pattern: /^\d{9}$/ },
  { label: "ES (+34)", value: "+34", pattern: /^\d{9}$/ },
  { label: "LK (+94)", value: "+94", pattern: /^\d{9}$/ },
  { label: "SD (+249)", value: "+249", pattern: /^\d{9}$/ },
  { label: "SR (+597)", value: "+597", pattern: /^\d{7}$/ },
  { label: "SE (+46)", value: "+46", pattern: /^\d{9}$/ },
  { label: "CH (+41)", value: "+41", pattern: /^\d{9}$/ },
  { label: "SY (+963)", value: "+963", pattern: /^\d{9}$/ },
  { label: "TW (+886)", value: "+886", pattern: /^\d{9,10}$/ },
  { label: "TJ (+992)", value: "+992", pattern: /^\d{9}$/ },
  { label: "TZ (+255)", value: "+255", pattern: /^\d{9}$/ },
  { label: "TH (+66)", value: "+66", pattern: /^\d{9}$/ },
  { label: "TG (+228)", value: "+228", pattern: /^\d{8}$/ },
  { label: "TO (+676)", value: "+676", pattern: /^\d{5,7}$/ },
  { label: "TT (+1)", value: "+1", pattern: /^\d{10}$/ },
  { label: "TN (+216)", value: "+216", pattern: /^\d{8}$/ },
  { label: "TR (+90)", value: "+90", pattern: /^\d{10}$/ },
  { label: "TM (+993)", value: "+993", pattern: /^\d{8}$/ },
  { label: "TV (+688)", value: "+688", pattern: /^\d{5,6}$/ },
  { label: "UG (+256)", value: "+256", pattern: /^\d{9}$/ },
  { label: "UA (+380)", value: "+380", pattern: /^\d{9}$/ },
  { label: "UY (+598)", value: "+598", pattern: /^\d{8}$/ },
  { label: "UZ (+998)", value: "+998", pattern: /^\d{9}$/ },
  { label: "VU (+678)", value: "+678", pattern: /^\d{7}$/ },
  { label: "VA (+39)", value: "+39", pattern: /^\d{9,10}$/ },
  { label: "VE (+58)", value: "+58", pattern: /^\d{10}$/ },
  { label: "VN (+84)", value: "+84", pattern: /^\d{9,10}$/ },
  { label: "YE (+967)", value: "+967", pattern: /^\d{9}$/ },
  { label: "ZM (+260)", value: "+260", pattern: /^\d{9}$/ },
  { label: "ZW (+263)", value: "+263", pattern: /^\d{9}$/ },
];